// extracted by mini-css-extract-plugin
module.exports = {"text":"css_text__ssYxK"};